var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupprimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00AECB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.075 20.942c-.054.369-.37.641-.742.641H2.847c-.372 0-.688-.272-.742-.64L-.609 2.492c-.067-.453.284-.86.742-.86h14.914c.458 0 .809.407.742.86l-2.714 18.45zm1.104-17.808H1l2.494 16.95h8.19l2.494-16.95z",
    transform: "translate(1 1) translate(2.036 .113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.597 1.137h5.986V2.19c0 .414.335.75.75.75.414 0 .75-.336.75-.75V.387c0-.414-.336-.75-.75-.75H3.847c-.414 0-.75.336-.75.75V2.19c0 .414.336.75.75.75.415 0 .75-.336.75-.75V1.137z",
    transform: "translate(1 1) translate(2.036 .113)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.876 6.301v10.14c0 .415.336.75.75.75s.75-.335.75-.75V6.302c0-.414-.336-.75-.75-.75s-.75.336-.75.75zM12.27 6.25l-.678 10.142c-.028.413.285.77.698.798.413.028.77-.285.799-.698l.678-10.14c.028-.414-.285-.772-.698-.8-.413-.027-.77.286-.799.699zM5.485 6.351l.678 10.14c.028.414.385.727.799.699.413-.028.726-.385.698-.798L6.981 6.25c-.027-.413-.385-.726-.798-.698-.413.027-.726.385-.698.798zM.509 3.247h18.234c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H.509c-.414 0-.75.336-.75.75s.336.75.75.75z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupprimer);
export default __webpack_public_path__ + "static/media/icon-supprimer.02b73608550ec0ae38fa16e07b70fd36.svg";
export { ForwardRef as ReactComponent };